export const roles = {
  restricted: 'RESTRICTED',
  fullAccess: 'FULL_ACCESS',
}
